import { faBars } from "@fortawesome/free-solid-svg-icons";
import { styles } from "../styles";

export function CoordDetailsButton(props: { title: string; onClick: () => void }) {
  const path = faBars.icon[4];
  return (
    <button
      class={styles.cardDetailsButton}
      type="button"
      title="詳細を表示"
      aria-label={`${props.title}の詳細を表示`}
      onClick={(event) => {
        event.stopPropagation();
        props.onClick();
      }}
    >
      <svg viewBox={`0 0 ${faBars.icon[0]} ${faBars.icon[1]}`} aria-hidden="true">
        <path fill="currentColor" d={Array.isArray(path) ? path.join(" ") : path} />
      </svg>
    </button>
  );
}
